import { Injectable, Inject} from '@angular/core';


export  class ClientAddressDO{
   	public id:Number;
	
	public  clientAddressID:String=null;
	
	public  typeCd:String=null;
	
	public  subTypeCd:String=null;

	public  addressLine1:String=null;

	public  addressLine2:String=null;
	
	public  addressLine3:String=null;
	
	public  addressLine4:String=null;

	public cityCd:String=null;

	public talukaCd:String=null;
	
	public  villageCd:String=null;
	
	public  stateCd:String=null;
	
	public  countryCd:String=null;

	public postCode:String=null;
	
	public  prefferedFl:boolean=null;


	
	public  getClientAddressID():String {
		return this.clientAddressID;
	}
	public  setClientAddressID(clientAddressID:String) {
		this.clientAddressID = clientAddressID;
	}
	public  getTypeCd():String {
		return this.typeCd;
	}
	public setTypeCd(addressTypeCd:String) {
		this.typeCd = addressTypeCd;
	}
	public getsubTypeCd():String {
		return this.subTypeCd;
	}
	public setsubTypeCd(subTypeCd:String) {
		this.subTypeCd = subTypeCd;
	}
	public  getAddressLine1():String {
		return this.addressLine1;
	}
	public setAddressLine1(addressLine1:String) {
		this.addressLine1 = addressLine1;
	}
	public  getAddressLine2():String {
		return this.addressLine2;
	}
	public setAddressLine2(addressLine2:String) {
		this.addressLine2 = addressLine2;
	}
	public  getAddressLine3():String {
		return this.addressLine3;
	}
	public setAddressLine3(addressLine3:String) {
		this.addressLine3 = addressLine3;
	}
	public  getAddressLine4():String {
		return this.addressLine4;
	}
	public setAddressLine4(addressLine4:String) {
		this.addressLine4 = addressLine4;
	}
	public  getCityCd():String {
		return this.cityCd;
	}
	public setCityCd( cityCd:String) {
		this.cityCd = cityCd;
	}
	public  getTalukaCd():String {
		return this.talukaCd;
	}
	public setTalukaCd(talukaCd:String) {
		this.talukaCd = talukaCd;
	}
	public  getVillageCd():String {
		return this.villageCd;
	}
	public setVillageCd(villageCd:String) {
		this.villageCd = villageCd;
	}
	public  getStateCd():String {
		return this.stateCd;
	}
	public setStateCd( stateCd:String) {
		this.stateCd = stateCd;
	}
	public  getCountryCd():String {
		return this.countryCd;
	}
	public setCountryCd( countryCd) {
		this.countryCd = countryCd;
	}
	public getPostCode():String {
		return this.postCode;
	}
	public setPostCode(postCode:String) {
		this.postCode = postCode;
	}
	public getId():Number {
		return this.id;
	}
	public setId(id:Number) {
		this.id = id;
	}
	public getPrefferedFl():boolean {
		return this.prefferedFl;
	}
	public setPrefferedFl(prefferedFl:boolean) {
		this.prefferedFl = prefferedFl;
	}
	

	

}